import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormlySelectOption } from '@common/interfaces/formly';
import { IssueService } from '@ep-om/project/state/issue/issue.service';
import { Observable } from 'rxjs';
import { catchError, delay, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

type MentionVm = {
  suggestions: Map<string, string[]>;
  suggestionKey: string;
};

const defaultIssueFieldKey = 'defaultIssueField';

@Component({
  selector: 'issue-field-mention',
  templateUrl: './issue-field-mention.component.html'
})
export class IssueFieldMentionComponent implements OnInit {
  @Input() wsForm: FormGroup;
  @Input() readonlyInterfaces: boolean = false;

  interfaceEntityMap: { [interfaceName: string]: string };
  taskTypes: { [taskType: string]: FormlySelectOption };
  taskTypesOptions: FormlySelectOption[];

  _mentionVm$: Observable<MentionVm>;

  _defaultIssueFieldKeyLabel = defaultIssueFieldKey;

  constructor(protected _fb: FormBuilder, 
    protected _issueService: IssueService, 
    private _httpClient: HttpClient) {}

  ngOnInit(): void {
    this._mentionVm$ = this._httpClient.get<string[]>(`${environment.apiUrl}/api/issue/issue-fields`).pipe(
      delay(100),
      map((issueFields) => {
        const vm = {
          suggestions: new Map(),
          suggestionKey: defaultIssueFieldKey
        };
        vm.suggestions.set(vm.suggestionKey, issueFields);
        return vm;
      }),
      catchError(err => {
        console.error(err);
        return [];
      })
    );
  }
}
